import script from "./Donate.vue?vue&type=script&setup=true&lang=ts"
export * from "./Donate.vue?vue&type=script&setup=true&lang=ts"

import "./Donate.vue?vue&type=style&index=0&id=1370e068&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1370e068"]])

export default __exports__